var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-btn-round',_vm._g(_vm._b({staticClass:"ui-btn-icon"},'ui-btn-round',_vm.$attrs,false),_vm.$listeners),[_c('ui-icon',{attrs:{"name":_vm.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }